module.exports = __webpack_public_path__ + "img/mastercard.6e2951b8.png";